<div class="d-flex justify-content-between align-items-center mt-4 mb-3">
    <h3 class="">
        Передплата
    </h3>
    <div class="custom-switch-control d-flex justify-content-between align-items-center"
         *ngIf="items.length">
        <button class="btn btn-sm p-1 toggle-button"
                [ngClass]="{'highlight': activePlan.id === items[0].id}"
                (click)="switchPlan(items[0])">{{items[0].frequency === 'monthly' ? 'місячна' : 'річна'}}</button>
        <i (click)="switchPlan(items[1])" *ngIf="activePlan.id === items[0].id"
           class="toggle highlight bi bi-toggle-off"></i>
        <i (click)="switchPlan(items[0])" *ngIf="activePlan.id === items[1].id"
           class="toggle highlight bi bi-toggle-on"></i>
        <button class="btn btn-sm p-1 toggle-button"
                [ngClass]="{'highlight': activePlan.id === items[1].id}"
                (click)="switchPlan(items[1])">{{items[1].frequency === 'monthly' ? 'місячна' : 'річна'}}</button>
    </div>
</div>

<div class="prices mb-5">
    <ng-container *ngFor="let item of items; let i=index">
        <div class="price-item" *ngIf="activePlan.id === items[i].id">
            <div class="value-wrapper"><span class="currency">₴</span><span
                    class="value">{{item.value}}</span><span
                    class="period">/місяць</span></div>
            <p>{{item.title}}</p>
        </div>
    </ng-container>
    <div *ngIf="activePlan?.frequency !== 'monthly' " class="free_trial_placeholder">
        Знижка -50%
    </div>
</div>
<div class="mt-5 order_details">
    <h3 class="mb-3">Деталі оплати</h3>
    <div class="d-flex justify-content-between align-items-center">
        <div>
            Anima AI &ndash; асистент<br>
            Нейронауковий трекер тривожності, стресу, вигорання та депресії<br>
            Персональні рекомендації та інсайти
        </div>
        <b class="pl-4" *ngIf="activePlan?.value">
            {{activePlan?.frequency !== 'monthly' ? activePlan?.value + ' ₴ * 12' : activePlan?.value + ' ₴'}}
        </b>
    </div>
    <hr>
    <div class="d-flex justify-content-between align-items-center">
        <div></div>
        <span>Загалом: <b>
                            {{activePlan?.frequency !== 'monthly' ? activePlan?.value + ' ₴ * 12 місяців' : activePlan?.value + ' ₴'}}
                        </b>
                        </span>
    </div>
</div>
<hr>

<ng-container *ngIf="!isLoggedIn">
    <button  (click)="login()" class="btn btn-block btn-link  text-center justify-content-center">
        {{'pricing.Please login to proceed payment' | translate}}
    </button>
</ng-container>
<form  [hidden]="!isLoggedIn" [formGroup]="form" class="mt-3 mb-3" (ngSubmit)="applyPromo(activePlan)">
    <label *ngIf="codeApplyed">Застосовано промокод</label>
    <div class="input-group mb-2 ">
        <input [disabled]="loading" [formControlName]="'promoCode'" class="form-control mr-2"
               type="text"
               placeholder="Ввести промокод"/>
        <button *ngIf="!codeApplyed" type="submit" class="action-btn hover_action"
                [disabled]="!form.valid || loading"
                (click)="applyPromo(activePlan)">
            Застосувати промо код
            <app-i-arrow></app-i-arrow>
        </button>
        <div *ngIf="loading" class="input-group-append">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>

        <small class="applyedIcon" *ngIf="!loading && !error && codeApplyed">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                 class="bi bi-percent"
                 viewBox="0 0 16 16">
                <path d="M13.442 2.558a.625.625 0 0 1 0 .884l-10 10a.625.625 0 1 1-.884-.884l10-10a.625.625 0 0 1 .884 0M4.5 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m7 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"/>
            </svg>
        </small>
    </div>
    <div><small class="text-danger" *ngIf="!loading && error">
        {{error}}
    </small></div>
</form>

<button [hidden]="!isLoggedIn" type="button" class="w-100 action-btn justify-content-center" [disabled]="loading"
        (click)="pay(activePlan)">
    <span>Перейти до оплати</span>
</button>
